import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-form__fields" }
const _hoisted_2 = { class: "login-form__actions" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "login-form__operationInfo" }
const _hoisted_6 = { key: 0 }

import { computed, ComputedRef, Ref, ref } from 'vue';
import BaseModal from './BaseModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AcumaticaLoginModal',
  props: {
	isUIBusy: Boolean,
	loginOperation: String
},
  emits: ['exit', 'credentials'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

const username: Ref<string> = ref('');
const password: Ref<string> = ref('');

const loginMessage: ComputedRef<string> = computed(() => {
	switch (props.loginOperation) {
		case 'active':
			return 'Logging in to Acumatica';
		case 'failed':
			return 'Login failed. Please try again';
		default:
			return '';
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    onClose: _cache[4] || (_cache[4] = ($event: any) => (emit('exit')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "login-form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('credentials', username.value, password.value)), ["prevent"]))
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("p", null, [
          _createElementVNode("span", { style: {"display":"block"} }, [
            _createElementVNode("b", null, "Login To Acumatica")
          ]),
          _createElementVNode("span", null, [
            _createElementVNode("i", null, "Your user session has expired or does not exist")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "username" }, "Username:", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "modal",
            id: "username",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event))
          }, null, 512), [
            [_vModelText, username.value]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "password" }, "Password:", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "modal",
            id: "password",
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "light",
            type: "submit",
            disabled: __props.isUIBusy
          }, "Login", 8, _hoisted_3),
          _createElementVNode("button", {
            class: "light",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('exit'))),
            disabled: __props.isUIBusy
          }, "Cancel", 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (__props.loginOperation)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(loginMessage.value), 1))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})